import { MenuItemIF } from "Components/NavBar/NavbarMenus/MoreButton";
import React from "react";
import styled from "styled-components";

const StyledSpan = styled.span`
  font-size: 14px;
  font-weight: 600;
`;

interface MenuItemProps {
  item: MenuItemIF;
}

const MenuItem: React.FC<MenuItemProps> = ({ item }) => {
  const { label, id } = item;
  return <StyledSpan id={String(id)}>{label}</StyledSpan>;
};

export default MenuItem;
